import { apiClient } from '@/shared/api/client'

export async function getLeads(params = {}) {
  const response = await apiClient.get('/admin/leads', {
    params,
  })

  return response.data
}

export async function getLeadById(leadId) {
  const response = await apiClient.get(`/admin/leads/${leadId}`)

  return response.data
}

export async function assignLead(leadId, salesPersonId) {
  const response = await apiClient.put(`/admin/leads/${leadId}/assign`, {
    salesPersonId,
  })

  return response.data
}

export async function sendFollowUpEmail(id) {
  const response = await apiClient.post(`/admin/leads/${id}/follow-up`)

  return response.data
}

export async function createLead(payload) {
  const response = await apiClient.post('/admin/leads', payload)
  return response.data
}

export async function updateLead(id, payload) {
  const response = await apiClient.put(`/admin/leads/${id}`, payload)
  return response.data
}

export async function updateLeadStatus(id, status) {
  const response = await apiClient.put(`/admin/leads/${id}`, { status })
  return response.data
}

export async function bulkUploadLeads(file) {
  const formData = new FormData()

  formData.append('file', file)

  const response = await apiClient.post('/admin/leads/bulk-upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })

  return response.data
}
